import { gql, useMutation } from 'urql';
import type { UpdateSettingInput } from '@features/modal-invitation/api/updateSetting';
import { SendContentType } from '@pages/event/api/useSendMessages';

export const SEND_INVITATION_MESSAGES_MUTATION = gql`
  mutation SendMessages(
    $ticketIds: [Int!]!
    $messageTemplate: String!
    $emailMessageTemplate: String!
    $contentType: String!
    $channel: [String!]!
    $eventSettings: UpdateSetting
  ) {
    sendMessages(
      ticketIds: $ticketIds
      messageTemplate: $messageTemplate
      emailMessageTemplate: $emailMessageTemplate
      contentType: $contentType
      channel: $channel
      eventSettings: $eventSettings
    ) {
      totalMessages
      attempt
      contentType
    }
  }
`;

export enum SendInvitationChannel {
  SMS = 'SMS',
  Email = 'EMAIL',
  VK = 'VK',
}

export interface SendInvitationMessagesInput {
  ticketIds: number[];
  messageTemplate: string | null;
  emailMessageTemplate: string | null;
  contentType: SendContentType;
  channel: SendInvitationChannel[];
  eventSettings?: UpdateSettingInput | null;
}

interface SendInvitationMessagesResponse {
  sendMessages: {
    totalMessages: number;
    attempt: number;
    contentType: string;
  };
}

export const useSendInvitationMessages = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<
    SendInvitationMessagesResponse,
    SendInvitationMessagesInput
  >(SEND_INVITATION_MESSAGES_MUTATION);

  const sendMessages = (variables: SendInvitationMessagesInput) => executeMutation(variables);

  return {
    data: data?.sendMessages,
    error,
    fetching,
    sendMessages,
  };
};
